function NoPageFound() {
  return <div>NoPageFound</div>;
}

export default NoPageFound;
